import cx from 'classnames'
import Image from 'next/image'
import Link from 'next/link'
import { FC, ReactNode } from 'react'

import '@/components/Layout/Footer/Atoms/FooterInfoLinkItem/FooterInfoLinkItem.scss'

export type FooterInfoLinkItemProps = {
  labelEn: string
  labelJa: string
  iconImage: any
  description: ReactNode
  href: string
  className?: string
}

const FooterInfoLinkItem: FC<FooterInfoLinkItemProps> = ({
  labelEn,
  labelJa,
  iconImage,
  description,
  href,
  className,
}) => {
  return (
    <li
      className={cx('c-footer-infoLinkItem u-font-yu-min', {
        [className as string]: className,
      })}
    >
      <Link className="c-footer-infoLinkItem__link" href={href}>
        <div className="c-footer-infoLinkItem__label">
          <p className="c-footer-infoLinkItem__label-en u-font-gb">{labelEn}</p>
          <p className="c-footer-infoLinkItem__label-ja">{labelJa}</p>
        </div>

        <div className="c-footer-infoLinkItem__icon-wrapper">
          <Image src={iconImage} alt="" width={iconImage.width} height={iconImage.height} />
        </div>

        <p className="c-footer-infoLinkItem__description">{description}</p>
      </Link>
    </li>
  )
}

export default FooterInfoLinkItem
